import { Input } from "../../../components/Input/Input";
import styles from "./BotsSettings.module.css";

/**
 * A number with its meaning written beside it rather than inside it — several
 * of them stacked make one field row ("bot msgs / hour", "gap between msgs",
 * …). The label is the accessible name, so a row of four boxes is four named
 * controls rather than four unlabelled spinners.
 *
 * Shared by four of the ten sections, which is why it sits in its own module
 * instead of inside whichever one happened to need it first.
 */
export function LabelledNumber({
  label,
  unit,
  value,
  onChange,
  wide,
}: {
  label: string;
  unit?: string;
  value: number;
  onChange: (n: number) => void;
  /** A label long enough to need the wider of the two label columns. */
  wide?: boolean;
}) {
  return (
    <div className={styles.pair}>
      <span
        className={`${styles.unit} ${wide ? styles.unitWider : styles.unitWide}`}
      >
        {label}
      </span>
      <Input
        className={styles.narrow}
        type="number"
        value={String(value)}
        onChange={(e) => onChange(Number(e.target.value))}
        aria-label={label}
      />
      {unit && <span className={styles.unit}>{unit}</span>}
    </div>
  );
}
